<template>
  <deposit-data-table></deposit-data-table>
</template>

<script>
import DepositDataTable from "./DepositDataTable.vue";

export default {
  components: { DepositDataTable },
}
</script>